import { render, staticRenderFns } from "./ClassificationChart.vue?vue&type=template&id=c4a07334&scoped=true&"
import script from "./ClassificationChart.vue?vue&type=script&lang=js&"
export * from "./ClassificationChart.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationChart.vue?vue&type=style&index=0&id=c4a07334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a07334",
  null
  
)

export default component.exports